import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Skeleton } from '../../components/ui/skeleton';
import { MapPin, Building } from 'lucide-react';

export const LocationSelection = ({ locations, loading, onSelect }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
        {[1, 2, 3].map(i => <Skeleton key={`skel-${i}`} className="h-24 sm:h-32 bg-white/10" />)}
      </div>
    );
  }

  if (locations.length === 0) {
    return (
      <Card className="bg-white/10 border-white/20">
        <CardContent className="p-6 sm:p-8 text-center">
          <MapPin className="h-10 w-10 sm:h-12 sm:w-12 mx-auto mb-4 opacity-50" />
          <p className="text-sm sm:text-base">Keine aktiven Standorte vorhanden</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
      {locations.map(location => (
        <button
          key={location.id}
          onClick={() => onSelect(location)}
          data-testid={`location-select-${location.id}`}
          className="bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-xl p-4 sm:p-6 text-left transition-all hover:scale-105 focus:outline-none focus:ring-2 focus:ring-primary active:scale-95"
        >
          <div className="flex items-start gap-3 sm:gap-4">
            <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-lg sm:rounded-xl bg-primary/20 flex items-center justify-center flex-shrink-0">
              <MapPin className="h-5 w-5 sm:h-7 sm:w-7 text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-bold text-base sm:text-lg truncate">{location.name}</h3>
              {location.branch_name && (
                <p className="text-gray-400 text-xs sm:text-sm flex items-center gap-1 mt-1">
                  <Building className="h-3 w-3" />
                  {location.branch_name}
                </p>
              )}
            </div>
          </div>
        </button>
      ))}
    </div>
  );
};
